import { _, Backbone, moment } from "../../vendor";

export default Backbone.Model.extend({
  initialize() {
    const that = this;

    // Format ISO to human time (API requirement for POST)
    if (typeof this._timeFilter != "undefined") {
      _.each(this._timeFilter, (filter) => {
        const val = that.get(filter);

        if (val != null && typeof val != "undefined") {
          if (val.toString().indexOf("+") >= 0) {
            that.set(filter, moment(val).format("YYYY-MM-DD HH:mm"));
          }
        }
      });
    }
  },

  parse(response) {
    // automatically set model data by using
    // our own API-response structure
    if (typeof response.success !== "undefined") {
      // Sometimes, invalid responses do not have an
      // invalid http-code besides response.success
      // Therefore, do not overwrite model with response.
      if (!response.success) {
        return false;
      }
    }
    return response.data;
  },
});
